import {
  compose,
  branch,
  renderComponent,
  withProps,
  withHandlers
} from 'recompose'
import { connect } from 'react-redux'
import moment from 'moment'
import { reduxForm } from 'redux-form'

import {
  withInitialData,
  subscriptionSelect
} from '../components/hoc'
import ElectronicServicePage from '../components/ElectronicService'
import ElectronicServiceValidSubscription from '../components/ElectronicService/WithValidSubscription'
import { postReverseProxyRedirect } from '../reducers/reverse-proxy'

const mapStateToProps = (state, ownProps) => {
  const products = state.products.list.length ? state.products.list : ownProps.products

  return {
    address: state.user.address,
    products: products.filter(item => item.product_type.key === 'ESI'),
    loading: state.reverseProxy.loading
  }
}

const mapDispatchToProps = dispatch => ({
  postReverseProxyRedirect: data => dispatch(postReverseProxyRedirect(data))
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps({
    title: 'common:esi',
    contentImage: ''
  }),
  withInitialData,
  subscriptionSelect,
  withHandlers({
    postReverseProxyRedirect: props => () => {
      const requestData = {
        language: props.language || 'en',
        isfromcanada: props.address.country === 'CA',
        firstname: props.user.first_name,
        lastname: props.user.last_name,
        addr: props.address.address1 || '',
        city: props.address.city || '',
        state: props.address.state || '',
        zip: props.address.zip || '',
        country: props.address.country || '',
        countrycode: props.address.country || '',
        email: props.user.username,
        accessstart: moment().subtract(1, 'd').toDate(),
        accessend: moment(props.user.sub_exp_date).toDate()
      }
      props.postReverseProxyRedirect(requestData)
        .then(response => {
          props.isClient ? window.open(response.redirect_url, "_blank") : null
        })
        .catch(error => {
          props.createNotification({
            type: 'error',
            message: props.t('server-error')
          })
        })
    },
  }),
  withHandlers({
    _handleSubmit: ({ postReverseProxyRedirect }) => () => {
      postReverseProxyRedirect()
    }
  }),
  reduxForm({
    form: 'reverse',
    destroyOnUnmount: true
  }),
  branch(
    ({ user }) => {
      if (user && user.sub_exp_date) {
        const expDate = moment(user.sub_exp_date)
        return moment().isBefore(expDate)
      }
    },
    renderComponent(ElectronicServiceValidSubscription)
  ),
)(ElectronicServicePage)



// WEBPACK FOOTER //
// ./pages/electronic-service.js